export default "__VITE_ASSET__3bf696fa__"